// extracted by mini-css-extract-plugin
export default {"chatIcon":"DreamInterpreter_chatIcon__fcrF3","pulse":"DreamInterpreter_pulse__xNhZ1","chatWindow":"DreamInterpreter_chatWindow__HUZiu"};